export{IconPosition,TabsComponent}from"./tabs.component.js";
//# sourceMappingURL=index.js.map
